import { render, staticRenderFns } from "./SocialList.vue?vue&type=template&id=69828e81&scoped=true&lang=pug&"
import script from "./SocialList.vue?vue&type=script&lang=js&"
export * from "./SocialList.vue?vue&type=script&lang=js&"
import style0 from "./SocialList.vue?vue&type=style&index=0&id=69828e81&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69828e81",
  null
  
)

component.options.__file = "SocialList.vue"
export default component.exports